import { Action } from '@ngrx/store';
import * as actions from '../actions';
import {Group} from '../../models/group';

export interface GroupdsState {
  Loaded: boolean;
  Loading: boolean;
  entities: Group[];
}

export const initialState: GroupdsState = {
  Loaded: false,
  Loading: false,
  entities: []
};

export function reducer(state = initialState, action: actions.GroupActions): GroupdsState {
  switch (action.type) {
    case actions.GroupActionTypes.GetGroups:
      return {...state, Loaded: false, Loading: true};
    case actions.GroupActionTypes.LoadGroups:
      return {...state, Loaded: true, Loading: false, entities: action.payload};

    default:
      return state;
  }
}
